import axios from "axios";

export const setTenantId = (tenantId) => {
    if (tenantId) {
        axios.defaults.headers.common["tenantId"] = tenantId;
        axios.defaults.headers.common["TenantId"] = tenantId;
    } else {
        delete axios.defaults.headers.common["tenantId"];
        delete axios.defaults.headers.common["TenantId"];
    }
};